import { createSlice } from "@reduxjs/toolkit";

import { RootState } from "store";
import { AuthFlow, TierType, User, UserType } from "types/users";

interface UserState {
  user: User;
}

const initialState: UserState = {
  user: {
    id: "",
    name: "",
    username: "",
    is_superuser: false,
    tier: TierType.Free,
    groups: [],
    explore_detector: "",
    userprofile: {
      accepted_terms_of_service: "",
      name: "",
      company: "",
      show_system_accuracy: false,
      customer_type: UserType.Customer,
      data_onboarded: false,
      detector_detail_onboarded: false,
      query_detail_onboarded: false,
      review_onboarded: false,
      detector_management_onboarded: false,
    },
    is_admin_login_view: false,
    is_labeler: false,
    is_staff: false,
    accepted_tos: false,
    email: "",
    auth_flow: AuthFlow.COGNITO,
    date_joined: "",
    account_labeling_settings: "FULL_LABELING",

    // Feature flags
    // --- Currently OFF for everyone
    show_inspections: false,
    show_reset_detector_option: false,
    // --- Customer type based
    show_labelers_management: false,
    enable_idp_migration: false,
    can_edit_gl_notes: false,
    enable_review_options: false,
    show_disagreements: false,
    should_create_disagreements: false,
    allow_explore_selection: false,
    show_full_sources: false,
    only_labeler_ui: false,
    show_disagreements_management: false,
    // --- Customer tier based
    allow_annotations: false,
    enable_export_data: false,
    enable_count_mode: false,
    enable_multi_class_mode: false,
    enable_bounding_box_mode: false,
    // --- Temporary internal test
    show_system_accuracy: false,
    enable_new_detector_notes_editor: false,
    enable_data_page_multiselect_filter: false,
    enable_text_mode: false,
    enable_account_invite: false,
    show_pipeline_details_modal: false,
  },
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuthUser: (state, action) => {
      state.user = action.payload;
    },
    setExploreDetector: (state, action) => {
      state.user.explore_detector = action.payload;
    },
  },
});

export const { setAuthUser, setExploreDetector } = authSlice.actions;
export const getUserState = (state: RootState): User => state.auth.user;

export default authSlice;
